var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#188C19",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,4.40772004 L12.0964361,1.23621128 C12.0602243,1.14361318 11.9752825,1.08370346 11.8815514,1.08465246 C11.8521342,1.07844918 11.82187,1.07844918 11.7924528,1.08465246 L10,1.90980606 L11.4570231,3.12788996 C11.6584044,3.29745813 11.7885185,3.54587217 11.8186583,3.81832461 C11.8409725,4.02283843 11.8063266,4.22985287 11.7190776,4.41333333 L13.3333333,4.40772004 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67807453,2.94250278 C7.92948995,3.05308964 8.12946869,3.26252748 8.23506097,3.52583501 C8.33934307,3.78912467 8.33934307,4.08504378 8.23506097,4.34833344 L8.23506097,4.40666667 L10.9587246,4.40666667 L11.2037987,4.08000062 C11.2648775,3.96171485 11.2284279,3.8141101 11.1202507,3.74166793 L6.92057298,0.294174479 C6.86898255,0.252091563 6.80347289,0.233347165 6.738618,0.242111367 C6.6737631,0.25087557 6.61494225,0.28642144 6.57524138,0.340841057 L5.4,1.92167139 L7.67807453,2.94250278 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37138389,3.58096163 L2.96000326,1.09082078 C2.90617649,1.05994639 2.84522936,1.05861924 2.7906577,1.08713321 C2.73608605,1.11564718 2.6923928,1.17164946 2.66925317,1.24273918 L1.66666667,4.4 L7.34130629,4.4 L7.4816684,3.96406022 C7.50510031,3.8931369 7.50610754,3.81283165 7.48446705,3.74092686 C7.46282657,3.66902208 7.42032402,3.6114509 7.36637095,3.58096163 L7.37138389,3.58096163 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8052239,5.51652293 C14.6685422,5.33090034 14.468681,5.227128 14.2603661,5.2336208 L0.709752048,5.2336208 C0.505033486,5.23125574 0.309615447,5.33433818 0.174578682,5.51592319 C0.0395419177,5.6975082 -0.0216911015,5.93954647 0.00688545856,6.17877109 L0.835069347,12.859119 C0.886170894,13.2641049 1.18006493,13.5644911 1.52703878,13.5663743 L13.4594251,13.5663743 C13.8146424,13.5774269 14.1209753,13.2738873 14.1731888,12.859119 L14.9959241,6.17877109 C15.0181988,5.93564118 14.9484153,5.69330297 14.8052239,5.51652293 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.46b23b9518153ae920b65106fbcf3ba7.svg";
export { ForwardRef as ReactComponent };